import {
  Modals,
  AdditionArgsRequierdModalsName,
  ResetModalType,
  initialState,
} from "../../cache/model/modal";
import { ReactiveVar } from "@apollo/client";

export const createModalMutations = (modalVar: ReactiveVar<Modals>) => {
  const initializeModalState = () => modalVar(initialState);
  const openModal = (
    modalName: keyof Omit<Modals, AdditionArgsRequierdModalsName>,
  ) => modalVar({ ...modalVar(), [modalName]: { isOpen: true } });

  const openSecretCodeModal = (
    name: string,
    title: string,
    secretCode: string,
  ) =>
    modalVar({
      ...modalVar(),
      secretCode: { isOpen: true, name, title, secretCode },
    });

  const openPrescriptionCompletedModal = (prescriptionId: string) =>
    modalVar({
      ...modalVar(),
      prescriptionCompleted: { isOpen: true, prescriptionId },
    });

  const openExtendPrescriptionCodeExpiryCompletedModal = (
    name: string,
    expiry: string,
  ) =>
    modalVar({
      ...modalVar(),
      extendPrescriptionCodeExpiryCompleted: {
        isOpen: true,
        name,
        expiry,
      },
    });

  const openResetModal = (type: ResetModalType) =>
    modalVar({ ...modalVar(), reset: { isOpen: true, type } });

  const closeModal = (modalName: keyof Modals) =>
    modalVar({ ...modalVar(), [modalName]: { isOpen: false } });

  const openConfirmUsedCodeModal = (supportUrl: string) =>
    modalVar({ ...modalVar(), confirmUsedCode: { isOpen: true, supportUrl } });

  return {
    initializeModalState,
    openModal,
    openSecretCodeModal,
    openPrescriptionCompletedModal,
    openExtendPrescriptionCodeExpiryCompletedModal,
    openResetModal,
    closeModal,
    openConfirmUsedCodeModal,
  };
};
